import { endpoints, request } from '!core/api';

export const generalConditionsServices = {
  getFile: () =>
    request.get(endpoints.chnn('wsbGetDocuments?context=COND_GERAIS')),
  downloadFile: ({ documentId, documentVersion }) =>
    request.downloadFile(endpoints.chnn('wsbGetDocument'), {
      documentId,
      documentVersion,
    }),
  setGeneralConditions: ({ documentId, documentVersion }) =>
    request.put(
      endpoints.chnn(
        `wsbSetGeneralConditions?documentId=${documentId}&documentVersion=${documentVersion}`,
      ),
    ),
};
